import React, { createContext, useContext } from "react";
import { Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProfileDropdown from "./ProfileDropdown";
import AppContext from "../../context/Context";
import { faBell, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { Button } from "reactstrap";
import ButtonIcon from "../common/ButtonIcon";
import classNames from "classnames";
import NotificationDropdown from "./NotificationDropdown";
import { faRocketchat } from "@fortawesome/free-brands-svg-icons";
import AI_ICON from "../../assets/img/icons/generative_ai_icon.png"

const TopNavRightSideNavItem = () => {
  const { isTopNav, isCombo, isRTL, isDark } = useContext(AppContext);

  //  const chatUrl = `${process.env.PUBLIC_URL}/admin/Chatbox`;
  let type = "";
  const { loginUserDetails } = useContext(AppContext);
  if (loginUserDetails.is_partner === "1") {
    type = "user";
  } else {
    type = "admin";
  }

  const chatUrl = `${process.env.PUBLIC_URL}/${type}/Chatbox`;
  const aiApiPlus = `${process.env.PUBLIC_URL}/${type}/apiplusplus`;

  const isExcludesEndpoint = (window.location.href.includes("Chatbox") || window.location.href.includes("apiplusplus"));


  return (
    <Nav
      navbar
      className="navbar-nav-icons ml-auto flex-row align-items-center justify-content-center"
      as="ul"
    >
      {/* <Nav.Item as={"li"}>
        <Nav.Link className="px-2 theme-control-toggle" onClick={{}}>
          <OverlayTrigger
            key="left"
            placement={isRTL ? "bottom" : "left"}
            overlay={<Tooltip id="ThemeColor">{isDark ? "Switch to light theme" : "Switch to dark theme"}</Tooltip>}
          >
            <div className="theme-control-toggle-label">
              <FontAwesomeIcon icon={isDark ? faSun : faMoon} className="fs-0" />
            </div>
          </OverlayTrigger>
        </Nav.Link>
      </Nav.Item> */}
      {!isExcludesEndpoint ? (<>
        {window.location.href.includes("qa") ? (
          <a
          href={aiApiPlus}
          target="_blank"
          rel="noreferrer"
          className="mr-2"
          style={{marginTop:"1.5px"}}
        >
          
          Build Application 
          <img src={AI_ICON} alt="AI_ICON_API_PLUS" height={"25"} style={{
            filter:"invert(38%) sepia(100%) saturate(500%) hue-rotate(180deg)",
            marginRight:"0.1em"
          }} 
          />
        </a>
        ):(null)}</>
        
      ) : null}

      {!isExcludesEndpoint ? (
        <a
          href={chatUrl}
          target="_blank"
          rel="noreferrer"
          className="mr-1"
          // style={{ textDecoration: "none", color: "inherit" }}
        >
          Ask Me <FontAwesomeIcon icon={faRocketchat} />
          &nbsp;
        </a>
      ) : null}
      {!isExcludesEndpoint ? (
        <NotificationDropdown />
      ) : null}

      {!isExcludesEndpoint ? (
        <Button
          size="sm"
          rounded
          className="btn-theme-control-toggle"
          onClick={() => {
            window.localStorage.setItem("isDark", !isDark);
            window.location.reload(false);
          }}
        >
          <FontAwesomeIcon icon={isDark ? faSun : faMoon} />
        </Button>
      ) : null}

      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
